import { createSlice } from '@reduxjs/toolkit'
import { IOrderReducers, IOrderState } from './order.types'

const initialState: IOrderState = {
  loading: false,
  error: null,
}

const { actions, reducer } = createSlice<IOrderState, IOrderReducers, 'order'>({
  name: 'order',
  initialState,
  reducers: {
    createOrderRequest: (state) => {
      state.error = null
      state.loading = true
    },
    createOrderResponse: (state, action) => {
      state.loading = false
      state.expPaymentDate = action.payload.expPaymentDate
      state.error = null
    },
    createOrderError: (state, action) => {
      state.error = action.payload.errorMessage
      state.loading = false
    },
  },
})

export { actions as OrderActions }

export { reducer as orderReducer }
